"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChangeOverTime {
    constructor(startValue, targetValue, startDay, targetDay, onStep) {
        this.startValue = startValue;
        this.targetValue = targetValue;
        this.startDay = startDay;
        this.targetDay = targetDay;
        this.onStep = onStep;
    }
    calculate(stepDay) {
        let a = this.targetDay - this.startDay;
        let b = (stepDay - this.startDay) / a;
        if (Math.abs(b) >= 1) {
            return this.targetValue;
        }
        let c = this.targetValue - this.startValue;
        return this.startValue + (b * c);
    }
    notify() {
        if (this.onStep) {
            this.onStep();
        }
    }
}
exports.ChangeOverTime = ChangeOverTime;



// WEBPACK FOOTER //
// ./src/changeOverTime.js